export const normalizeOptionalId = (value) => (
  value === null || value === undefined || value === "" ? null : value
);

const getInputListRowKey = (item) => {
  const label = item?.Label ?? item?.label;
  if (typeof label !== "string") {
    return null;
  }

  const separatorIndex = label.indexOf(" - ");
  if (separatorIndex === -1) {
    return null;
  }

  return label.slice(0, separatorIndex).trim() || null;
};

const getQuestionGroups = (questions, columnCount) => {
  if (columnCount > 1) {
    const grouped = [];

    for (let rowStart = 0; rowStart < questions.length; rowStart += columnCount) {
      grouped.push(questions.slice(rowStart, rowStart + columnCount));
    }

    return grouped;
  }

  const grouped = [];
  let currentGroup = [];
  let currentRowKey = null;

  questions.forEach(item => {
    const rowKey = getInputListRowKey(item);

    if (rowKey && rowKey === currentRowKey) {
      currentGroup.push(item);
      return;
    }

    if (currentGroup.length > 0) {
      grouped.push(currentGroup);
    }

    currentGroup = [item];
    currentRowKey = rowKey;
  });

  if (currentGroup.length > 0) {
    grouped.push(currentGroup);
  }

  return grouped;
};

export const repairInputListQuestionHeritage = (questions = [], columnHeadings = []) => {
  if (!Array.isArray(questions) || questions.length === 0) {
    return [];
  }

  const repaired = [];
  const columnCount = Array.isArray(columnHeadings) ? columnHeadings.length : 0;

  const pushRepairedHeritage = (item, repairToQuestionId) => {
    const heritageId = normalizeOptionalId(item?.HeritageId ?? item?.heritageId);
    const questionId = normalizeOptionalId(item?.Id ?? item?.id);
    const shouldUseQuestionId = heritageId === null || repairToQuestionId;

    repaired.push({
      heritageId: shouldUseQuestionId
        ? (questionId ?? heritageId ?? null)
        : heritageId,
      usedQuestionIdFallback: shouldUseQuestionId && questionId !== null && questionId !== heritageId
    });
  };

  const questionGroups = getQuestionGroups(questions, columnCount);

  questionGroups.forEach(rowItems => {
    const heritageCounts = new Map();
    const heritageSeen = new Map();

    rowItems.forEach(item => {
      const heritageId = normalizeOptionalId(item?.HeritageId ?? item?.heritageId);
      if (heritageId !== null) {
        const key = String(heritageId);
        heritageCounts.set(key, (heritageCounts.get(key) || 0) + 1);
      }
    });

    const duplicateHeritageIds = new Set(
      Array.from(heritageCounts.entries())
        .filter(([, count]) => count > 1)
        .map(([heritageId]) => heritageId)
    );

    rowItems.forEach(item => {
      const heritageId = normalizeOptionalId(item?.HeritageId ?? item?.heritageId);
      const key = heritageId === null ? null : String(heritageId);
      const seenCount = key === null ? 0 : (heritageSeen.get(key) || 0);
      const repairToQuestionId = key !== null
        && duplicateHeritageIds.has(key)
        && seenCount > 0;

      if (key !== null) {
        heritageSeen.set(key, seenCount + 1);
      }

      pushRepairedHeritage(item, repairToQuestionId);
    });
  });

  return repaired;
};
